import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "heartrate-module__select"
}

import { ref, computed } from 'vue'
import BaseModule from './BaseModule.vue'
import {
  NInputNumber,
  NInputGroup,
  NInputGroupLabel,
  NForm,
  NProgress,
  NFormItem,
} from 'naive-ui'
import { useI18n } from 'vue-i18n'

//Store
import { useMqttStore } from '@/store/mqttStore'
import { useDeviceStore } from '@/store/deviceStore'
import { storeToRefs } from 'pinia'
import { BfIcon, Colors } from '@finetic/bikefitting-ui'
import { deviceType } from '@/types/device'
import PairDevices from '@/components/controls/PairDevices.vue'

import { heartRateDefinitions, heartRate } from '@/mqttDefinitions'
import {
  valueAsPercentage,
  HEARTRATE_MIN,
  HEARTRATE_MAX,
} from '@/outputVariables'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeartrateModule',
  setup(__props) {

const { t } = useI18n()
const mqttStore = useMqttStore()
const deviceStore = useDeviceStore()

const changeDevice = ref(false)

const { getMessageOnTopic } = storeToRefs(mqttStore)
const { heartRateStatus } = storeToRefs(deviceStore)

//Data init
const heartRateValue = computed(() => {
  return getMessageOnTopic.value(heartRate)
})

const heartRateAsPercentage = computed(() => {
  return valueAsPercentage(heartRateValue.value, HEARTRATE_MAX, HEARTRATE_MIN)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModule, {
    definition: _unref(heartRateDefinitions),
    connected: _unref(heartRateStatus).connected,
    connecting: _unref(heartRateStatus).connecting,
    "content-active": _unref(heartRateStatus).connected && !_unref(heartRateStatus).connecting
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('modules.heartrate.index')), 1)
    ]),
    config: _withCtx(() => [
      _createElementVNode("div", {
        class: "heartrate-module__settings",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeDevice.value = true))
      }, [
        _createVNode(_unref(BfIcon), {
          icon: "/icons/01-Interface Essential/12-Settings/cog.svg",
          color: _unref(Colors).Light
        }, null, 8, ["color"])
      ])
    ]),
    middle: _withCtx(() => [
      _createVNode(_unref(NProgress), {
        class: "heartrate__indicator",
        type: "line",
        height: 12,
        "show-indicator": false,
        percentage: heartRateAsPercentage.value
      }, null, 8, ["percentage"])
    ]),
    bottom: _withCtx(() => [
      _createVNode(_unref(NForm), {
        ref: "formRef",
        "label-placement": "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            label: _unref(t)('modules.heartrate.index'),
            class: "heartrate__output"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputNumber), {
                    value: heartRateValue.value,
                    "show-button": false,
                    readonly: ""
                  }, null, 8, ["value"]),
                  _createVNode(_unref(NInputGroupLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(heartRate).unit), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 512),
      (changeDevice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(PairDevices, {
              type: _unref(deviceType).heartRate,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (changeDevice.value = false))
            }, null, 8, ["type"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["definition", "connected", "connecting", "content-active"]))
}
}

})